module.exports = __webpack_public_path__ + "static/media/candy-cane.5aae2f43.svg";